import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@vaiu/ui/button';
import { EthereumProvider } from '@/context/EthereumContext';
import EthereumWalletDashboard from '@/components/ethereum/EthereumWalletDashboard';

const EthereumFundingPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <EthereumProvider>
      <div className="container mx-auto py-6 px-4 max-w-4xl">
        <div className="mb-6">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => navigate('/')}
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back Home
          </Button>
        </div>

        <EthereumWalletDashboard />
      </div>
    </EthereumProvider>
  );
};

export default EthereumFundingPage;
